import { Checkbox as WebSDKCheckbox } from '@zambezi/sdk/form-elements';
import React, { forwardRef, useId } from 'react';
import FormControl from '../FormControl';
import './Checkbox.scss';

export interface CheckboxProps {
  label: React.ReactNode | React.ReactNode[];
  name: string;
  disabled?: boolean;
  pii?: boolean;
  required?: boolean;
  error?: string | boolean;
  defaultChecked?: boolean;
  checked?: boolean;
  value?: string | number;
  tooltip?: string | React.ReactNode | React.ReactNode[];
  tooltipAriaLabel?: string;
  hideLabel?: boolean;
  inputProps?: Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>;
  onChange?: (event: Event, checked: boolean) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      label,
      name,
      disabled = false,
      required = false,
      pii = false,
      value,
      error,
      checked,
      defaultChecked,
      tooltip,
      tooltipAriaLabel,
      hideLabel = false,
      inputProps = {},
      onChange,
      onBlur,
      onFocus
    },
    ref
  ) => {
    const id = useId();
    return (
      <FormControl
        id={id}
        tooltip={tooltip}
        tooltipAriaLabel={tooltipAriaLabel}
        error={error}
        required={required}
        pii={pii}
      >
        <WebSDKCheckbox
          className="mss-checkbox"
          label={
            <>
              {label}{' '}
              {required && (
                <span className="mss-form-control-required" aria-hidden>
                  *
                </span>
              )}
            </>
          }
          id={id}
          name={name}
          disabled={disabled}
          aria-invalid={!!error}
          aria-describedby={error ? `error-${id}` : undefined}
          aria-required={required}
          value={value}
          defaultChecked={defaultChecked}
          error={!!error}
          checked={checked}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          ref={ref}
          withLabel={!hideLabel}
          iconProps={{
            title: '',
            name: 'core-checkbox-checked'
          }}
          {...inputProps}
        />
      </FormControl>
    );
  }
);

export default Checkbox;
